export enum ProjectStatus {
    UNAVAILABLE = 'UNAVAILABLE',
    PROCESSING = 'PROCESSING'
}
